<div class="d-flex" id="wrapper" style="padding-top: 30px;">

    <div class="border-right side" id="sidebar-wrapper" [ngClass]="status ? 'hide' : 'show'">
        <!-- <div class="sidebar-heading">
            <a><img src="../../../assets/img/home-two/logo.jpg" alt="Logo" style="width: 210px;"></a>
        </div> -->
        <div class="list-group list-group-flush">
            <br />
            <a [routerLink]="['/admin/AllPages']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/AllPages')}"><i class='bx bx-file'></i>All Pages</a>
            <a [routerLink]="['/admin/PagePost']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/PagePost')}"><i class='bx bx-plus'></i>Add Pages</a>
            <!-- <a [routerLink]="['/admin/GetallJobs']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/GetallJobs')}"><i class='bx bx-briefcase'></i>Jobs</a>
            <a [routerLink]="['/admin/Jobpost']" routerLinkActive="active"
                class="list-group-items list-group-item-action" [ngClass]="{'highlight': isActive('/admin/Jobpost')}">
                <i class='bx bx-plus-circle'></i>Add Jobs</a>
            <a [routerLink]="['/admin/AppliedCandidates']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/AppliedCandidates')}"> <i
                    class='bx bx-user-check'></i>Resumes</a> -->
            <a [routerLink]="['/admin/Contacts']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/Contacts')}"><i class='bx bx-envelope'></i>Contacts</a>
            <a [routerLink]="['/admin/Email-Settings']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/Email-Settings')}"><i class='bx bx-cog'></i>Email-Settings</a>
            <!-- <a [routerLink]="['/admin/ClientImages']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/ClientImages')}"><i class='bx bx-image'></i>Client Images</a> -->
            <a [routerLink]="['/admin/metataggetall']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/metataggetall')}"><i class='bx bx-tag'></i>MetaGet all</a>
            <a [routerLink]="['/admin/metapost']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/metapost')}"><i class='bx bx-tag-alt'></i>Meta Post</a>
            <a [routerLink]="['/admin/Blogs']" routerLinkActive="active" class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/Blogs')}"> <i class='bx bx-book'></i>Blogs</a>
            <a [routerLink]="['/admin/addBlogs']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/addBlogs')}"><i class='bx bx-plus'></i>Add Blogs</a>
                <a [routerLink]="['/admin/faq']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/faq')}"><i class='bx bx-plus'></i>Faq's</a>
                <a [routerLink]="['/admin/gallery']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/gallery')}"><i class='bx bx-plus'></i>Gallery</a>
                <a [routerLink]="['/admin/team']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/team')}"><i class='bx bx-plus'></i>Team</a>
                <a [routerLink]="['/admin/testimonials']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/testimonials')}"><i class='bx bx-plus'></i>Testimonials</a>

            <!-- <a [routerLink]="['/admin/addevent']" routerLinkActive="active"
                class="list-group-items list-group-item-action" [ngClass]="{'highlight': isActive('/admin/addevent')}">
                <i class='bx bx-book'></i>Add Event</a>
            <a [routerLink]="['/admin/ourevents']" routerLinkActive="active"
                class="list-group-items list-group-item-action"
                [ngClass]="{'highlight': isActive('/admin/ourevents')}"><i class='bx bx-plus'></i>Our Events</a> -->
        </div>

    </div>
    <!-- /#sidebar-wrapper -->
    <!-- <p-confirmDialog header="Logout Confirmation" icon="pi pi-exclamation-triangle">
        Are you sure you want to log out?
      </p-confirmDialog> -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
        <header class="header-area">
            <div class="navbar-area">
                <div class="floza-responsive-nav">
                    <div class="container">
                        <div class="floza-responsive-menu">
                            <div class="logo">

                                <i class='bx bx-menu' (click)="clickEvent()"></i>
                                <!-- <button class="btn "  > <span class="navbar-toggler-icon"></span></button>
                                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                    aria-expanded="false" aria-label="Toggle navigation">
                                    <span class="navbar-toggler-icon"></span>
                                </button>   -->
                                <!-- <a><img src="../../../../assets/img/KarnaIT.png" alt="logo"></a> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="floza-nav">
                    <div class="container">
                        <nav class="navbar navbar-expand-md navbar-light">
                            <button class="btn " (click)="clickEvent()"> <span
                                    class="navbar-toggler-icon"></span></button>
                            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                            <div class="collapse navbar-collapse mean-menu">
                                <ul class="navbar-nav ml-auto">
                                    <!-- <li class="nav-item">
                                           <a href="javascript:void(0)" class="nav-link">Jobs <i
                                                   class='bx bx-chevron-down'></i></a>
           
                                           <ul class="dropdown-menu">
                                               <li class="nav-item"><a routerLink="/admin/Jobpost" class="nav-link"
                                                       routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Job
                                                       Post</a></li>
           
                                               <li class="nav-item"><a routerLink="/admin/GetallJobs" class="nav-link"
                                                       routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">All
                                                       Jobs</a></li>
           
                                           </ul>
                                       </li> -->
                                    <!-- <li class="nav-item">
                                           <a href="javascript:void(0)" class="nav-link">Pages <i
                                                   class='bx bx-chevron-down'></i></a>
           
                                           <ul class="dropdown-menu">
                                               <li class="nav-item"><a routerLink="/admin/PagePost" class="nav-link"
                                                       routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                                       Add Page</a></li>
           
                                               <li class="nav-item"><a routerLink="/admin/AllPages" class="nav-link"
                                                       routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">All
                                                       Pages</a></li>
           
                                           </ul>
                                       </li> -->
                                    <!-- <li class="nav-item"><a routerLink="/admin/Contacts" class="nav-link"
                                               routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Contact</a></li> -->

                                    <li class="nav-item">
                                        <a href="javascript:void(0)" class="nav-link"><i class='bx bx-user'></i>Admin <i
                                                class='bx bx-chevron-down'></i></a>

                                        <ul class="dropdown-menu">
                                            <li class="nav-item" (click)="logout()"><a class="nav-link"
                                                    routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                                    Logout</a></li>

                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
        <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light">

            <div class="container-fluid">

               
               
            </div>
        </nav> -->

        <div class="container-fluid" style="padding-top: 70px;">
            <router-outlet></router-outlet>
        </div>
    </div>
    <!-- /#page-content-wrapper -->

</div>
<!-- /#wrapper -->